import { useContext } from "react";
import { PoolsPageContext } from "./PoolsPageContextProvider";

const usePoolsPageContext = () => {
  return useContext(PoolsPageContext);
};

export default usePoolsPageContext;
